import type { AxiosInstance } from 'axios'

import apiClient from './apiClient'

/**
 * Project service — one service per backend resource, and the only place
 * that calls the HTTP client (React_TypeScript_Standards.md §4).
 * Mirrors StagehandAPI's ProjectDto contract.
 */

export type ProjectDto = {
  id: number
  /** JDE project number — the natural key, e.g. "1142". */
  projectNumber: string
  projectName: string
}

export type ProjectService = {
  /** Active projects ordered by project number — the switcher's list. */
  getActive: (signal?: AbortSignal) => Promise<ProjectDto[]>
}

export function createProjectService(client: AxiosInstance): ProjectService {
  return {
    getActive: async (signal) => {
      const response = await client.get<ProjectDto[]>('/api/project', {
        signal,
      })
      return response.data
    },
  }
}

export const projectService = createProjectService(apiClient)
